import React, { useEffect, useRef } from 'react';

interface ParallaxElementProps {
  children?: React.ReactNode;
  speed?: number;
  className?: string;
  /** Clamp the translation to +/- this many pixels so the element never drifts far from its base position. */
  maxOffset?: number;
}

export function ParallaxElement({ children, speed = 0.5, className = '', maxOffset }: ParallaxElementProps) {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      let parallax = scrolled * speed;

      if (maxOffset !== undefined) {
        parallax = Math.max(-maxOffset, Math.min(maxOffset, parallax));
      }

      element.style.transform = `translate3d(0, ${parallax}px, 0)`;
    };

    handleScroll();

    // Use passive listener para melhor performance
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [speed, maxOffset]);

  return (
    <div 
      ref={elementRef}
      className={`parallax-element ${className}`}
    >
      {children}
    </div>
  );
}
